import ctl from "@netlify/classnames-template-literals";

import type { ToastVariant } from "./index";

interface ContainerStyles {
  body: string;
  toast: string;
}

export const closeButton = ctl(`
  cursor-pointer
  absolute
  right-3
  top-4
`);

export const container = (variant: ToastVariant): ContainerStyles => {
  const toastBodyBase = ctl(`  
    flex
    items-center
    justify-center
    p-3
    w-full
    rounded-2xl
    text-neutral-900
    shadow-[0_4px_12px_0_rgba(28,24,49,0.24)]
  `);
  const toastToastBase = ctl(`
    relative
    rounded-2xl
  `);

  const variantClasses = {
    default: {
      body: `${toastBodyBase} bg-status-info-50`,
      toast: `${toastToastBase}`,
    },
    info: {
      body: `${toastBodyBase} bg-status-info-50`,
      toast: `${toastToastBase}`,
    },
    success: {
      body: `${toastBodyBase} bg-status-success-50`,
      toast: `${toastToastBase}`,
    },
    warning: {
      body: `${toastBodyBase} bg-status-caution-50`,
      toast: `${toastToastBase}`,
    },
    error: {
      body: `${toastBodyBase} bg-status-error-50`,
      toast: `${toastToastBase}`,
    },
  };

  return variantClasses[variant];
};
